import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]理财首页模块列表
 */
export function moduleListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListLcHomePageParam> {
  return resource.postNoAuth('/lcHomePage/moduleList', req, config);
}
/**
 * [No Auth]理财首页获取客户总资产
 */
export function getTotalAssets(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/investor/renewal/client/asset', req, config);
}
/**
 * [No Auth]理财首页获取是否合格资管投资者
 */
export function getIsQualifiedAsset(req: void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/client/verified', req, config);
}
/**
 * [No Auth]理财首页获取合格投资者有效期
 */
export function getQualifiedAssetExpireDate(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/investor/renewal/client/expiration', req, config);
}
/**
 * [No Auth]理财首页查询是否需要展示弹窗
 */
export function getIsShowExpireTip(req: void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/show/tips', req, config);
}
/**
 * [No Auth]保存客户的选项(是否展示)
 */
export function saveIsShowExpireTip(req: saveIsShowExpireTipDto, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/save/isShow', req, config);
}
/**
 * [No Auth]保存客户的选项(当天是否展示)
 */
export function saveDayShowExpireTip(req: saveIsShowExpireTipDto, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/save/dayShow', req, config);
}
